export class StatusFatoresAltenticacao {
    tokenOtpObrigatorio: boolean;
    usuarioCadastrouPin: boolean;
    usuarioCadastrouTokenOtp: boolean;
}